import React, { useState, useEffect } from "react";
import { privateApi } from "../../api/axiosConfig";
import { useAuth } from "../../services/auth";
import WishlistUI from "./WishlistUI";

const PAGE_SIZE = 12;

export default function Wishlist() {
  const [likes, setLikes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { isAuthenticated } = useAuth();

  // Pagination State
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  useEffect(() => {
    document.title = "لیست علاقمندی‌ها";
  }, []);

  const fetchLikes = async (currentPage = 1) => {
    if (!isAuthenticated) {
      setError("لطفاً برای مشاهده لیست علاقمندی‌ها وارد حساب کاربری خود شوید.");
      setLoading(false);
      return;
    }

    setLoading(true);
    try {
      const res = await privateApi.get("/api/v1/products/likes/", {
        params: { page: currentPage },
      });

      const items = Array.isArray(res.data)
        ? res.data
        : Array.isArray(res.data?.results)
        ? res.data.results
        : [];

      setLikes(items);

      if (res.data?.total_pages) {
        setTotalPages(res.data.total_pages);
      } else if (res.data?.count) {
        setTotalPages(Math.ceil(res.data.count / PAGE_SIZE));
      } else {
        setTotalPages(1);
      }

      setError(null);
    } catch (err) {
      console.error("Failed to fetch wishlist", err);
      setError("خطا در دریافت لیست علاقمندی‌ها.");
      setLikes([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLikes(page);
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [page]);

  const handlePageChange = (event, value) => {
    setPage(value);
  };

  const handleRemoveLike = async (e, productId) => {
    e.preventDefault();
    e.stopPropagation();

    try {
      await privateApi.post("/api/v1/products/likes/", { product: productId });

      const updatedLikes = likes.filter(
        (item) => Number(item?.product?.id) !== Number(productId)
      );
      setLikes(updatedLikes);

      if (updatedLikes.length === 0 && page > 1) {
        setPage((prev) => prev - 1);
      } else if (updatedLikes.length === 0) {
        fetchLikes(page);
      }
    } catch (err) {
      console.error("Failed to remove from wishlist", err);
    }
  };

  return (
    <WishlistUI
      likes={likes}
      loading={loading}
      error={error}
      page={page}
      totalPages={totalPages}
      onPageChange={handlePageChange}
      onRemoveLike={handleRemoveLike}
    />
  );
}